/**
 * @generated SignedSource<<c94d94e838503db6dbec55e48d117bac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type contentSubmissionEnd_AnswersResultQuery$variables = {
  submissionId: string;
};
export type contentSubmissionEnd_AnswersResultQuery$data = {
  readonly LearnV2: {
    readonly GetAnswersResult: ReadonlyArray<{
      readonly answers: ReadonlyArray<string>;
      readonly correctAnswerIndices: ReadonlyArray<number>;
      readonly question: string;
      readonly selectedAnswersIndices: ReadonlyArray<number>;
    }>;
  };
};
export type contentSubmissionEnd_AnswersResultQuery = {
  response: contentSubmissionEnd_AnswersResultQuery$data;
  variables: contentSubmissionEnd_AnswersResultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Queries",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "submissionId",
            "variableName": "submissionId"
          }
        ],
        "concreteType": "MultipleChoiceResult",
        "kind": "LinkedField",
        "name": "GetAnswersResult",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "correctAnswerIndices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "selectedAnswersIndices",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contentSubmissionEnd_AnswersResultQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentSubmissionEnd_AnswersResultQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f304ec28779fd05a1f8b5f63f989a623",
    "id": null,
    "metadata": {},
    "name": "contentSubmissionEnd_AnswersResultQuery",
    "operationKind": "query",
    "text": "query contentSubmissionEnd_AnswersResultQuery(\n  $submissionId: ID!\n) {\n  LearnV2 {\n    GetAnswersResult(submissionId: $submissionId) {\n      question\n      answers\n      correctAnswerIndices\n      selectedAnswersIndices\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cac890e2a647a1890a88e04e8eccc199";

export default node;
